module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-6-699901c1064c1af0c6807edeb6878dee.jpg";